<virtual-table [columns]="columns" [data]="data" [loadingMore]="loadingMore" [hasMoreData]="hasMoreData"
  (onLoadMore)="onLoadMore()" [rowClickable]="true" (onRowSelected)="onRowSelected($event)"
  (onRowClicked)="onRowClicked($event)" (onSelectAll)="onSelectAll($event)" [selectedRows]="selectedRows"
  [highlightedRows]="highlightedRows" [rowDraggable]="rowDraggable" (onRowDragStart)="onRowDragStart($event)"
  [sorted]="sorted" (onSort)="onSort($event)" [selectAll]="selectAll" (onColumnsModified)="onColumnsModified($event)"
  [noDataText]="(searchText ? 'NO_RESULTS_FOR_THIS_SEARCH' : 'NO_DATA') | translate">
  <ng-template #actionCellTemplate let-row>
    <ion-button fill="clear" size="small" (click)="onRowAction(row, 'new-activity')" [tooltip]="'NEW_ACTIVITY' | translate">
      <ion-icon slot="icon-only" class="plus-icon" src="assets/imgs/plus.svg"></ion-icon>
    </ion-button>
    <!-- <ion-button fill="clear" size="small" (click)="onRowAction(row, 'more')">
      <ion-icon slot="icon-only" name="ellipsis-horizontal" style="height: 20px"></ion-icon>
    </ion-button> -->
  </ng-template>
</virtual-table>
<ng-template #configureColumnsModal>
  Coming soon...
</ng-template>
<ng-template #configureFilterModal>
  Coming soon...
</ng-template>
<ng-template #configureTagsModal let-tags let-showSearchBar="showSearchBar" let-onSearch="onSearch" let-self="self" let-searchText="searchText">
  <div class="configure-tags-modal" slot="fixed">
    <ion-searchbar *ngIf="showSearchBar" [value]="searchText" placeholder="Search" autoFocusSearchbar (ionInput)="onSearch($event.detail.value, self)" debounce="100"></ion-searchbar>
    <ion-content>
      <ion-list>
        <ion-item-sliding *ngFor="let tag of tags; trackBy: trackById" #options>
          <ion-item [class.deleted]="tag.deleted" [disabled]="tag.deleted">
            <ion-checkbox slot="start" [checked]="tag.selected && !tag.deleted" (ionChange)="tag.selected = $event.detail.checked" [disabled]="tag.deleted"></ion-checkbox>
            {{ tag.name }}
            <!-- <ion-button fill="clear" size="small" style="--color: var(--ion-color-danger)" slot="end" (click)="tag.deleted = !tag.deleted">
              <ion-icon slot="icon-only" [name]="tag.deleted ? 'trash' : 'trash-outline'"></ion-icon>
            </ion-button> -->
          </ion-item>
          <ion-item-options side="end">
            <ion-item-option color="danger" (click)="tag.deleted = !tag.deleted; options.close()">
              <ion-icon slot="icon-only" name="trash"></ion-icon>
            </ion-item-option>
          </ion-item-options>
        </ion-item-sliding>
      </ion-list>
    </ion-content>
  </div>
</ng-template>
